/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";

interface BookingLoginTableRowColumnProps {
    className?: string;
    children: React.ReactNode | React.ReactNode[];
}

const BookingLoginTableRowColumn = (props: BookingLoginTableRowColumnProps) => {
    return (
        <div className={clsx(props.className, "BookingLoginTableRowColumn col-span-1 inline-flex py-1.5 lg:py-1 px-3 sm:px-1.5 lg:px-1.5")}>
            {props.children}
        </div>
    );
};

export default BookingLoginTableRowColumn;
